import MuiSkeleton from '@mui/material/Skeleton';

export interface SkeletonProps {
  variant?: 'text' | 'rectangular' | 'rounded' | 'circular';
  width?: number | string;
  height?: number | string;
  animation?: 'pulse' | 'wave' | false;
}

// Loading placeholder behind the facade. Sizing goes through the curated
// `width`/`height` props rather than `sx`. Omit unset optionals: the project's
// exactOptionalPropertyTypes rejects forwarding `undefined`.
export function Skeleton({ variant = 'text', width, height, animation = 'pulse' }: SkeletonProps) {
  return (
    <MuiSkeleton
      variant={variant}
      animation={animation}
      {...(width !== undefined ? { width } : {})}
      {...(height !== undefined ? { height } : {})}
    />
  );
}
